import React, { Component } from "react";
import ChangePasswordForm from '../components/password-form.jsx';
class ChangePassword extends Component {

	render() {
		return (
			<React.Fragment>
				<section className="hero is-medium is-primary is-bold">
					<div className="hero-body">
						<div className="container">
							<h1 className="title">Repository immagini</h1>
							<h2 className="subtitle">Nuova password</h2>
						</div>
					</div>
				</section>
				<section className="section">
					<div className="container">
						<div className="columns is-centered has-text-left">
							<div className="column is-narrow signup">
								<ChangePasswordForm history={this.props.history}/>
							</div>
						</div>
					</div>
				</section>
			</React.Fragment>
		)
	}
}

export default ChangePassword;


// WEBPACK FOOTER //
// ./src/views/change-password.jsx